export const formatCurrency = (amount: number, currency?: string) => {
  try {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: currency || 'USD',
    }).format(amount);
  } catch {
    return `$${amount.toFixed(2)}`;
  }
};

export const formatDate = (date: Date) =>
  new Intl.DateTimeFormat('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  }).format(date);

export const splitFileName = (name: string, extension: string) => ({
  base: name.replace(/\.[^./\\]+$/, ''),
  suffix: extension ? `.${extension}` : '',
});
